<div class="table-responsive">
  <table class="table table-bordered mt-2" *ngIf="lstTask && lstTask.length > 0 || !IsModeCursus">
    <thead>
      <tr>
        <th class="noBorder widthContainerEtat"><label class="font-weight-bold ">Etat</label></th>
        <th [ngClass]="!IsModeCursus ? 'noBorder' : 'noBorderHeader' " class="widthContainerEtatColor"></th>
        <th [ngClass]="!IsModeCursus ? 'noBorder' : 'noBorderHeader' " class="widthContainerAvatar"></th>
        <th [ngClass]="!IsModeCursus ? 'noBorder' : 'noBorderHeader' "><label class="font-weight-bold widthContainerLibelle">Intitulé</label></th>
        <th [ngClass]="!IsModeCursus ? 'noBorder' : 'noBorderHeader' "><label class="font-weight-bold widthContainerDate">Date de début</label></th>
        <th [ngClass]="!IsModeCursus ? 'noBorder' : 'noBorderHeader' "><label class="font-weight-bold widthContainerDate">Date limite</label></th>
        <th [ngClass]="!IsModeCursus ? 'noBorder' : 'noBorderHeader' "><label class="font-weight-bold widthContainerDuree">Temps</label></th>
        <th [ngClass]="!IsModeCursus ? 'noBorder' : 'noBorderHeader' "><label class="font-weight-bold widthContainerDepense">Dépenses HT</label></th>
        <th [ngClass]="!IsModeCursus ? 'noBorder' : 'noBorderHeader' "><label class="font-weight-bold widthContainerCommentaire">Commentaire</label></th>
        <th class="noBorder"></th>
      </tr>
    </thead>

    <tbody>
      <!-- AJOUT D'UNE TACHE -->
      <tr *ngIf="!IsModeCursus && !ReloadAddRow">
        <td class="noBorder"></td>
        <td class="noBorder"></td>
        <td class="noBorder">
          <q-avatar-search class="mr-2"
                           [nullable]="true"
                           [mode]="'COLLAB'"
                           (selectedList)="OnCollaboChange($event,'create')">
          </q-avatar-search>
        </td>
        <td class="noBorder"><div><input [(ngModel)]="taskToAdd.Libelle" class="widthInputLibelle q-input-no-border inputText p-1" type="text" name="libelle" placeholder="EX: Envoyer questionnaire de positionnement" /></div></td>
        <td class="noBorder"><div><q-date [(ngValue)]="taskToAdd.DateDebut" required></q-date></div></td>
        <td class="noBorder"><div><q-date [(ngValue)]="taskToAdd.DateLimite" required></q-date></div></td>
        <td class="noBorder"><div><input min="0" [(ngModel)]="taskToAdd.Temps" class="q-input-no-border inputText p-1" type="number" name="temps" placeholder="EX: 1" /></div></td>
        <td class="noBorder"><div><input min="0" [(ngModel)]="taskToAdd.Depense" class="q-input-no-border inputText p-1" type="number" name="depense" placeholder="EX: 10.00" /></div></td>
        <td class="noBorder"><div><input [(ngModel)]="taskToAdd.Commentaire" class="widthContainerCommentaire q-input-no-border inputText p-1" type="text" name="commentaire" placeholder="EX: Amener son ordinateur" /></div></td>
        <td class="noBorder pl-4 p-1 ">
          <button (click)="VerifyInformations('create')" class="q-btn q-main">
            <i [ngClass]="[ isSaving ? 'fas fa-spin fa-spinner fa-pulse' : 'fas fa-save']"></i>
          </button>
        </td>
      </tr>

      <ng-container *ngIf="lstTask && lstTask.length > 0 else templateNoData">
        <!-- AFFICHAGE DES TACHES -->
        <tr *ngFor="let task of lstTask" class="position-relative">

          <!-- MODE VUE ET CURSUS -->
          <ng-container *ngIf="!task.ModeEditable">

            <td class="noBorder align-middle">
              <i (click)="ChangeEtatTask(task)"
                 [ngClass]="task.Etat == '3' ? 'q-c-success' : 'q-c-dark-grey'"
                 class="fas fa-check-circle fa-md">
              </i>
            </td>
            <td [ngClass]="{'q-warning':task.EtatCouleur == 1 && task.Etat != '3',
                            'q-danger':task.EtatCouleur == 2 && task.Etat != '3',
                            'q-dark-grey':task.EtatCouleur == 3 && task.Etat != '3',
                            'q-success': task.Etat == '3'}"
                class="noRightLeftBorderInCell align-middle">
            </td>
            <td class="noRightLeftBorderInCell align-middle">
              <img *ngIf="task.ImageCollabo && task.ImageCollabo != ''; else emptyBlock" class="rounded-circle widthImageAvatar" [src]="task.ImageCollabo" alt="ImgCollabo" />
              <ng-template #emptyBlock><div class="container-user-plus"><i class="fas fa-user"></i></div></ng-template>
            </td>
            <td class="noRightLeftBorderInCell align-middle widthInputLibelle">{{task.Libelle}}</td>
            <td class="noRightLeftBorderInCell align-middle">{{task.DateDebut | qDate}}</td>
            <td class="noRightLeftBorderInCell align-middle">{{task.DateLimite | qDate}}</td>
            <td class="noRightLeftBorderInCell align-middle">
              <span *ngIf="task.Temps">{{task.Temps}} h</span>
            </td>
            <td class="noRightLeftBorderInCell align-middle">
              <span *ngIf="task.Depense">{{task.Depense | money}}</span>
            </td>
            <td class="noRightLeftBorderInCell align-middle text-center" style="border-right: 1px solid rgba(0,0,0,0.1);">
              <span *ngIf="task.HasCommentaire" title="{{task.Commentaire}}">{{task.Commentaire}}</span>
            </td>


            <!-- Boutons mode vue -->
            <td class="noBorder align-middle">
              <div class="d-flex justify-content-around aligns-item-center" *ngIf="!IsModeCursus">

                <div *ngIf="!hideButton && task.Etat != '3'" class="mx-1" title="Modifier">
                  <i (click)="ActivateModeEdit(task)" class="q-c-secondary fas fa-pen-alt"></i>
                </div>

                <div *ngIf="!hideButton && task.Etat != '3'" class="mx-1" title="workflow automatique">
                  <i (click)="ActivateModeEditWorkflow(task)"  [ngClass]="{'fa-solid fa-gears q-c-warning':task.ActionAutomatique !== '' || task.CreationAutomatique,'fas fa-user q-c-light-secondary':task.ActionAutomatique === '' && !task.CreationAutomatique }" ></i>
                </div>

                <div *ngIf="!hideButton && task.Etat != '3'" class="mx-1" title="Ouverture du détail de la tache">
                  <i *ngIf="task?.IdentTache && task?.IdentTache != '0'" (click)="openBoTache(ModalBO, task)" class="q-c-main fas fa-edit"></i>
                </div>


                <div *ngIf="!hideButton && task.Etat != '3'" class="mx-1" title="Supprimer">
                  <i (click)="OpenDelete(ModalDeleteValidation, task)" class="q-c-danger fas fa-trash-alt"></i>
                </div>


              </div>
            </td>

          </ng-container>


          <!-- MODE EDIT -->
          <ng-container *ngIf="task.ModeEditable">
            <td class="noBorder align-middle">
              <i (click)="ChangeEtatTask(task)"
                 [ngClass]="task.Etat == '3' ? 'q-c-main' : 'q-c-dark-grey'"
                 class="fas fa-check-circle fa-md">
              </i>
            </td>
            <td [ngClass]="{'q-warning':task.EtatCouleur == 1 && task.Etat != '3',
                            'q-danger':task.EtatCouleur == 2 && task.Etat != '3',
                            'q-dark-grey':task.EtatCouleur == 3 && task.Etat != '3',
                            'q-main': task.Etat == '3'}"
                class="noRightLeftBorderInCell align-middle">
            </td>
            <td class="noRightLeftBorderInCell align-middle  ">
              <!-- avatarEdit -->
              <q-avatar-search class="avatar-user"
                               [value]="editTask.IdentCollabo | avatarSearchValue"
                               [nullable]="true"
                               [mode]="'COLLAB'"
                               (selectedList)="OnCollaboChange($event,'update')">
              </q-avatar-search>
            </td>
            <td class="noRightLeftBorderInCell align-middle widthInputLibelle"><div class="d-flex flex-column font-weight-bold"><input [(ngModel)]="editTask.Libelle" class="widthInputLibelle q-input-no-border inputText p-1" type="text" name="libelle" [placeholder]="task.Libelle" /></div></td>
            <td class="noRightLeftBorderInCell align-middle widthDate"><div class="d-flex flex-column font-weight-bold"><q-date [(ngValue)]="editTask.DateDebut" (isValid)="isDateDebut = $event" required></q-date></div></td>
            <td class="noRightLeftBorderInCell align-middle widthDate"><div class="d-flex flex-column font-weight-bold"><q-date [(ngValue)]="editTask.DateLimite" (isValid)="isDateFin = $event" required></q-date></div></td>
            <td class="noRightLeftBorderInCell align-middle"><div><input min="0" [(ngModel)]="editTask.Temps" class="q-input-no-border inputText p-1 " type="number" name="temps" [placeholder]="task.Temps" /></div></td>
            <td class="noRightLeftBorderInCell align-middle"><div><input min="0" [(ngModel)]="editTask.Depense" class="q-input-no-border inputText p-1 " type="number" name="depense" [placeholder]="task.Depense" /></div></td>
            <td class="noRightLeftBorderInCell align-middle" style="border-right: 1px solid rgba(0,0,0,0.1);"><div class="d-flex flex-column font-weight-bold"><input [(ngModel)]="editTask.Commentaire" class="q-input-no-border inputText p-1" type="text" name="commentaire" [placeholder]="task.Commentaire" /></div></td>
            <!-- BOUTON QUI SONT AFFICHER EN MODE EDITABLE -->
            <td class="noBorder align-middle">
              <div class="d-flex justify-content-around aligns-item-center">
                <div title="Annuler">
                  <i (click)="CloseModeEdit(task)" class="q-c-danger fas fa-times"></i>
                </div>
                <div title="Enregistrer">
                  <i (click)="VerifyInformations('update')" class="q-c-main fas fa-save"></i>
                </div>
              </div>
            </td>
          </ng-container>

        </tr>
      </ng-container>
    </tbody>

    <tfoot>
      <!-- DUREE ET DEPENSES TOTALES -->
      <tr>
        <td class="noBorder"></td>
        <td class="noBorder"></td>
        <td class="noBorder"></td>
        <td class="noBorder"></td>
        <td class="noBorder"></td>
        <td class="noBorder font-weight-bold widthTotalDuree">Nombre : {{NombreTotal}} </td>
        <td class="noBorder font-weight-bold widthTotalDuree">Durée totale : {{totalTempsStage}} h </td>
        <td class="noBorder font-weight-bold widthTotalDepenses">Total dépenses : {{totalDepenseStage | money }} </td>
        <td class="noBorder"></td>
        <td class="noBorder"></td>
      </tr>
    </tfoot>

  </table>
</div>


<!-- MODAL MODE AUTO -->
<ng-template #content let-modal class="modal-dialog-centered">

  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Sélection des tâches</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span class="h2" aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <button class="q-btn q-main ml-3 mb-1" (click)="CreateAutoTaskWithList();modal.dismiss()"><i class="fas fa-save mr-1"></i>Ajouter</button>
    <div class="q-check ml-3 mt-3">
      <input (change)="AddRemoveAllTaskAuto()" [(ngModel)]="allTaskAutoSelected" type="checkbox" id="selectAllTaskAuto" />
      <label for="selectAllTaskAuto">
        <span></span>Tout sélectionner
      </label>
    </div>
    <div class="table-responsive">
      <table class="table table-bordered">

        <thead>
          <tr>
            <th class="noBorderHeader widthCheckAuto"></th>
            <th class="noBorderHeader widthImageAvatar"></th>
            <th class="noBorderHeader widthLibelleAuto">Intitulé</th>
            <th class="noBorderHeader">Temps</th>
            <th class="noBorderHeader">Dépense</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let taskAuto of lstTaskAuto;let index = index">
            <td class="noRightLeftBorderInCell align-middle">
              <div class="q-check">
                <input [(ngModel)]="taskAuto.IsSelected" (change)="AddAutoTaskInList(taskAuto)" type="checkbox" id="task-{{index}}" />
                <label for="task-{{index}}">
                  <span></span>
                </label>
              </div>
            </td>
            <td class="noRightLeftBorderInCell align-middle">
              <div class="container-user-plus">
                <i [ngClass]="{'fa-solid fa-gears':taskAuto.ActionAutomatique !== '' || taskAuto.CreationAutomatique,'fas fa-user':taskAuto.ActionAutomatique === '' && !taskAuto.CreationAutomatique }" ></i>
              </div>
            </td>
            <td class="noRightLeftBorderInCell align-middle">{{taskAuto.Libelle}}</td>
            <td class="noRightLeftBorderInCell align-middle">{{taskAuto.Temps}}h</td>
            <td class="noRightLeftBorderInCell align-middle">{{taskAuto.Depense | money}}</td>
          </tr>
        </tbody>

      </table>
    </div>
  </div>

</ng-template>


<ng-template #contentParam let-modal class="modal-dialog-centered">

  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Modification,création tâches automatiques (version BETA)</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span class="h2" aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="affichageliste">
      <div class="d-flex flex-column">
        <div class="d-flex" *ngFor="let taskP of lstTaskParam;let index = index">
          <div (click)="SelectTaskParam(taskP.Code)" class="container-user-plus mb-1 ">
            <i [ngClass]="{'fa-solid fa-gears':taskP.ActionAutomatique !== '' || taskP.CreationAutomatique,'fas fa-user':taskP.ActionAutomatique === '' && !taskP.CreationAutomatique }" ></i>
          </div>
          <span class="mb-1 ml-3">{{taskP.Intitule}}</span>
        </div>
      </div>
      <div class="d-flex flex-column">

        <div class="affichagetitre">
          <div class="container-user-plus"><i class="fas fa-user"></i></div>
          <label class="font-weight-bold widthContainerLibelle  ml-1">Intitulé</label>
          <input [(ngModel)]="taskParam.Intitule" class="widthInputLibelle q-input-no-border inputText " type="text" name="libelle" placeholder="EX: Envoyer questionnaire de positionnement" />
        </div>
        <div class="affichagetitre">
          <div style="width:35px"></div>
          <label class="font-weight-bold widthContainerLibelle  ml-1">Temps</label>
          <input min="0" [(ngModel)]="taskParam.Temps" class="q-input-no-border inputText p-1" type="number" name="temps" placeholder="EX: 1" />
        </div>
        <div class="affichagetitre">
          <div style="width:35px"></div>
          <label class="font-weight-bold widthContainerLibelle ml-1">Dépense</label>
          <input min="0" [(ngModel)]="taskParam.Depense" class="q-input-no-border inputText p-1" type="number" name="depense" placeholder="EX: 10.00" />
        </div>
        <div class="affichagetitre">
          <div style="width:35px"></div>
          <label class="font-weight-bold widthContainerLibelle ml-1">Commentaire</label>
          <input min="0" [(ngModel)]="taskParam.Commentaire" class="widthContainerCommentaire q-input-no-border inputText p-1" type="text" name="commentaire" placeholder="EX: Amener son ordinateur" />
        </div>
        <div class="affichagetitre">
          <div style="width:35px"></div>
          <label class="font-weight-bold widthContainerLibelle ml-1">Date de référence</label>
          <select class="q-main-select widthSelect" [(ngModel)]="taskParam.DateReference">
            <option value="datedPRO">Date début de stage</option>
            <option value="datefPRO">Date fin de stage</option>
          </select>
        </div>
        <div class="affichagetitre">
          <div style="width:35px"></div>
          <label class="font-weight-bold widthContainerLibelle ml-1">Décalage en jours (+/-)</label>
          <input [(ngModel)]="taskParam.NbDeJourDecalage" class="q-input-no-border inputText p-1" type="number" name="temps" placeholder="EX: 2 ou -2" />
        </div>
        <div class="affichagetitre">
          <div style="width:35px"></div>
          <label class="font-weight-bold widthContainerLibelle ml-1">Préaffectation</label>
          <select class="q-main-select widthSelect" [(ngModel)]="taskParam.CodeRelaColla">
            <option value="REL_RESPONSABLE_BO_STAGE">responsable du stage</option>
            <option value="REL_BO_FORMATEUR_BO_STAGE">formateur</option>
            <option value="0">Créateur de la tache</option>
          </select>
        </div>

        <div class="affichagetitre" style="border-top: 1px solid rgba(0,0,0,.2)">
          <div class="container-user-plus  mt-2"><i class="fa-solid fa-gears"></i></div>
          <label class="font-weight-bold widthContainerLibelle ml-1">action automatique</label>
          <select class="q-main-select widthSelect" [(ngModel)]="taskParam.ActionAutomatique">
            <option value=""></option>
            <option value="EnvoyerAuxClients">Envoyer mail aux Clients</option>
            <option value="EnvoyerAuxApprenants">Envoyer mail aux apprenants</option>
            <option value="EnvoyerAuxFormateurs">Envoyer mail aux formateurs</option>
            <option value="EnvoyerAuxResponsables">Envoyer mail aux Responsables RH</option>
            <option value="ConnaissanceAvantNonFait">Relancer questionnaire connaissance avant non fait</option>
            <option value="PratiqueAvantNonFait">Relancer questionnaire pratique avant non fait</option>
            <option value="ConnaissanceApresNonFait">Relancer questionnaire connaissance apres non fait</option>
            <option value="PratiqueApresNonFait">Relancer questionnaire pratique apres non fait</option>
            <option value="SatisfactionStagiaireNonFait">Relancer questionnaire satisfaction apprenant non fait</option>
            <option value="SatisfactionRHNonFait">Relancer questionnaire satisfaction responsable rh non fait</option>
            <option value="QuestionFormateurNonFait">Relancer questionnaire formateur non fait</option>
            <option value="QuestionAfroidStagiaireNonFait">Relancer questionnaire satisfaction à froid non fait</option>
            <option value="QuestionCertificationNonFait">Relancer questionnaire cetification non fait</option>
            <option value="EmargementNonFait">Relancer émargement non fait</option>
            <option value="RenvoyerCodeExtranetApprenant">Envoyer code extranet aux apprenants</option>
            <option value="RenvoyerCodeExtranetFormateur">Envoyer code extranet aux formateurs</option>
            <option value="RenvoyerCodeExtranetRespRH">Envoyer code extranet aux responsables RH</option>
            <option value="CreationDocument">Création d'un document</option>
          </select>
        </div>
        <div class="affichagetitre">
          <div style="width:35px"></div>
          <label class="font-weight-bold widthContainerLibelle ml-1">Sélection de l'émail</label>
          <select class="q-main-select widthSelect" [(ngModel)]="taskParam.ModeleEmail">
            <option *ngFor="let model of ModelsMail" [value]="model.value">{{model.key}}</option>
          </select>
        </div>
        <div class="affichagetitre" style="border-top: 1px solid rgba(0,0,0,.2)">
          <div class="container-user-plus  mt-2"><i class="fa-solid fa-gears"></i></div>
          <label class="font-weight-bold widthContainerLibelle ml-1">Sélection du document</label>

          <select class="q-main-select widthSelect" [(ngModel)]="taskParam.ModeleDocument">
            <option *ngFor="let combo of ModelsDoc; let i = index" value="{{combo.id}}">{{combo.value}}</option>
          </select>
        </div>
        <div class="affichagetitre">
          <div style="width:35px"></div>
          <label class="font-weight-bold widthContainerLibelle ml-1">Générer le document</label>
          <div class="q-check">
            <input type="checkbox" id="ckparamcredoc" [(ngModel)]="taskParam.CreationAutomatique" />
            <label class="q-label-checkreserv" for="ckparamcredoc">
              <span class="q-span-checkreserv"></span>
            </label>
          </div>
        </div>
        <div class="affichagetitre">
          <div style="width:35px"></div>
          <label class="font-weight-bold widthContainerLibelle ml-1">Attachement version pdf</label>
          <div class="q-check">
            <input type="checkbox" id="ckparampdf" [(ngModel)]="taskParam.AttachmentToPdf" />
            <label class="q-label-checkreserv" for="ckparampdf">
              <span class="q-span-checkreserv"></span>
            </label>
          </div>
        </div>
        <div class="affichagetitre" style="border-top: 1px solid rgba(0,0,0,.2)">
          <div class="container-user-plus mt-2"><i class="fas fa-tasks"></i></div>
          <label class="font-weight-bold widthContainerLibelle">Notifier collaborateur</label>
          <div class="q-check">
            <input type="checkbox" id="paramNotifColl" [(ngModel)]="taskParam.NotificationCollaborateur" />
            <label class="q-label-checkreserv" for="paramNotifColl">
              <span class="q-span-checkreserv"></span>
            </label>
          </div>
        </div>
        <div class="affichagetitre">
          <div style="width:35px"></div>
          <label class="font-weight-bold widthContainerLibelle">clôturer la tâche</label>
          <div class="q-check">
            <input type="checkbox" id="ParamClotTache" [(ngModel)]="taskParam.ClotureTache" />
            <label class="q-label-checkreserv" for="ParamClotTache">
              <span class="q-span-checkreserv"></span>
            </label>
          </div>
        </div>
        <div class="affichagetitre">
          <button class="q-btn q-main m-2" (click)="VerifyTaskParam()" title="Valider"><i class="fas fa-save "></i><label *ngIf="taskParam.Ident== '0'">Ajouter</label><label *ngIf="taskParam.Ident!='0'">Modifier</label></button>
          <button class="q-btn q-warning m-2" (click)="InitTaskParam()" title="Annuler les modifications" *ngIf="taskParam.Ident != '0'"><i class="fas fa-redo-alt fa-flip-horizontal"></i><label>Annuler</label></button>
          <button class="q-btn q-danger m-2" (click)="DeleteTaskParam()" title="Supprimer le paramétrage" *ngIf="taskParam.Ident != '0'"><i class="fas fa-times"></i><label>Supprimer</label></button>
        </div>
      </div>
    </div>
  </div>

</ng-template>

<!-- MODAL modification des workflows -->
<ng-template #contentWorkflow let-modal class="myModal">

  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title"><span>le: {{editTask.DateLimite.jour}}/{{editTask.DateLimite.mois}}/{{editTask.DateLimite.annee}} workflow: {{editTask.Libelle}} (version BETA)</span></h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span class="h2" aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="affichageliste">
      <div class="d-flex flex-column">
        <div class="affichagetitre" style="border-top: 1px solid rgba(0,0,0,.2)">
          <div class="container-user-plus  mt-2"><i class="fa-solid fa-gears"></i></div>
          <label class="font-weight-bold widthContainerLibelle ml-1">action automatique</label>
          <select class="q-main-select widthSelect" [(ngModel)]="editTask.ActionAutomatique">
            <option value=""></option>
            <option value="EnvoyerAuxClients">Envoyer mail aux Clients</option>
            <option value="EnvoyerAuxApprenants">Envoyer mail aux apprenants</option>
            <option value="EnvoyerAuxFormateurs">Envoyer mail aux formateurs</option>
            <option value="EnvoyerAuxResponsables">Envoyer mail aux Responsables RH</option>
            <option value="ConnaissanceAvantNonFait">Relancer questionnaire connaissance avant non fait</option>
            <option value="PratiqueAvantNonFait">Relancer questionnaire pratique avant non fait</option>
            <option value="ConnaissanceApresNonFait">Relancer questionnaire connaissance apres non fait</option>
            <option value="PratiqueApresNonFait">Relancer questionnaire pratique apres non fait</option>
            <option value="SatisfactionStagiaireNonFait">Relancer questionnaire satisfaction apprenant non fait</option>
            <option value="SatisfactionRHNonFait">Relancer questionnaire satisfaction responsable rh non fait</option>
            <option value="QuestionFormateurNonFait">Relancer questionnaire formateur non fait</option>
            <option value="QuestionAfroidStagiaireNonFait">Relancer questionnaire satisfaction à froid non fait</option>
            <option value="QuestionCertificationNonFait">Relancer questionnaire cetification non fait</option>
            <option value="EmargementNonFait">Relancer émargement non fait</option>
            <option value="RenvoyerCodeExtranetApprenant">Envoyer code extranet aux apprenants</option>
            <option value="RenvoyerCodeExtranetFormateur">Envoyer code extranet aux formateurs</option>
            <option value="RenvoyerCodeExtranetRespRH">Envoyer code extranet aux responsables RH</option>
            <option value="CreationDocument">Création d'un document</option>
          </select>
        </div>
        <div class="affichagetitre">
          <div style="width:35px"></div>
          <label class="font-weight-bold widthContainerLibelle ml-1">Sélection de l'émail</label>
          <select class="q-main-select widthSelect" [(ngModel)]="editTask.ModeleEmail">
            <option *ngFor="let model of ModelsMail" [value]="model.value">{{model.key}}</option>
          </select>
        </div>
        <div class="affichagetitre" style="border-top: 1px solid rgba(0,0,0,.2)">
          <div class="container-user-plus  mt-2"><i class="fa-solid fa-gears"></i></div>
          <label class="font-weight-bold widthContainerLibelle ml-1">Sélection du document</label>
          <select class="q-main-select widthSelect" [(ngModel)]="editTask.ModeleDocument">
            <option *ngFor="let combo of ModelsDoc; let i = index" value="{{combo.id}}">{{combo.value}}</option>
          </select>
        </div>
        <div class="affichagetitre">
          <div style="width:35px"></div>
          <label class="font-weight-bold widthContainerLibelle ml-1">Générer le document</label>
          <div class="q-check">
            <input type="checkbox" id="ckcreatdoc" [(ngModel)]="editTask.CreationAutomatique" />
            <label class="q-label-checkreserv" for="ckcreatdoc">
              <span class="q-span-checkreserv"></span>
            </label>
          </div>
        </div>
        <div class="affichagetitre">
          <div style="width:35px"></div>
          <label class="font-weight-bold widthContainerLibelle ml-1">attacher version pdf</label>
          <div class="q-check">
            <input type="checkbox" id="ckpdfversion" [(ngModel)]="editTask.AttachmentToPdf" />
            <label class="q-label-checkreserv" for="ckpdfversion">
              <span class="q-span-checkreserv"></span>
            </label>
          </div>
        </div>
        <div class="affichagetitre" style="border-top: 1px solid rgba(0,0,0,.2)">
          <div class="container-user-plus mt-2"><i class="fas fa-tasks"></i></div>
          <label class="font-weight-bold widthContainerLibelle">Notifier collaborateur</label>
          <div class="q-check">
            <input type="checkbox" id="NotificationCollaborateur" [(ngModel)]="editTask.NotificationCollaborateur" />
            <label class="q-label-checkreserv" for="NotificationCollaborateur">
              <span class="q-span-checkreserv"></span>
            </label>
          </div>
        </div>
        <div class="affichagetitre">
          <div style="width:35px"></div>
          <label class="font-weight-bold widthContainerLibelle">clôturer la tâche</label>
          <div class="q-check">
            <input type="checkbox" id="ClotureTache" [(ngModel)]="editTask.ClotureTache" />
            <label class="q-label-checkreserv" for="ClotureTache">
              <span class="q-span-checkreserv"></span>
            </label>
          </div>
        </div>
        <div class="affichagetitre">
          <button class="q-btn q-main m-2" (click)="VerifyInformations('update');modal.dismiss()" title="Valider"><i class="fas fa-save "></i><label>Modifier</label></button>
        </div>
      </div>
    </div>
  </div>

</ng-template>

<ng-template #templateNoData>
  <tr *ngIf="!lstTask || lstTask.length == 0">
    <td colspan="18" class="noBorder q-nodata q-c-light-main text-center">
      <p class="my-2"><i class="far fa-times-circle fa-2x"></i></p>
      Aucune donnée
    </td>
  </tr>
</ng-template>

<!-- Modals BO -->
<ng-template #ModalBO class="modal-dialog-centered" let-modalBO>
  <div class="p-4">
    <button type="button" class="close d-flex justify-content-end" (click)="modalBO.close('CANCEL')">
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="tabs">
      <ng-container *ngFor="let tab of tabs">
        <button *ngIf="tab.Visible" class="q-btn tab-button" [ngClass]="{'tab-select': tab.Active}" (click)="ActiveTab(tab.Type)" [disabled]="tab.Locked"><i [ngClass]="tab.Font"></i>{{tab.Name}}</button>
      </ng-container>
    </div>
    <div *ngIf="tabs[0].Visible">
      <q-bodisplay class="w-100 h-100 mb-5" [ngClass]="{'d-none': !tabs[0].Active }" [item]="modelBOTache" (sendEvent)="OnSaveBoTache($event);"></q-bodisplay>
    </div>
    <div *ngIf="tabs[1].Visible">
      <q-bodisplay class="w-100 h-100 mb-5" [ngClass]="{'d-none': !tabs[1].Active }" [item]="modelBODepense" (sendEvent)="OnSaveBoDepense($event);"></q-bodisplay>
    </div>


  </div>
</ng-template>


<!--  MODAL de validation de la suppression d'une tache -->
<ng-template #ModalDeleteValidation let-modal class="modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="q-c-main text-center">Etes-vous sûr de vouloir supprimer définitivement la tâche et sa dépense associée ?</h5>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="text-center">
      <button class="btn q-btn q-danger m-2" type="button" (click)="DeleteTask(selectedTache);modal.dismiss()"
              title="Supprimer la tâche">
        Supprimer
      </button>
    </div>
  </div>
</ng-template>
